import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/data/getDivisionList',
    method: 'post',
    params,
  })
}

// 获取契约管理NO
// API /api/tcntbasp
export function getContractManagementNoList(params) {
  return request({
    url: '/api/tcntbasp',
    method: 'get',
    params,
  })
}

// 获取契约管理NO日期
export function getContractManagementNoDate(params) {
  return request({
    url: '/api/tcntbasp',
    method: 'get',
    params,
  })
}

export function getWorkDayList() {
  return request({
    url: '/data/getWorkDayList',
    method: 'post',
  })
}
